export const mediumEnum = {
  Mixed: 'SearchAndContent',
  Search: 'Search',
  Content: 'Content',
  Audience: 'Audience',
};
